export default function getResource(label) {
    const resources = {
        accountClosed: 'Compte fermé avec succès',
        loggedOut: 'Vous êtes maintenant déconnecté.',
        message: 'If you have questions regarding closing your account please call our Customer Service team at',
        or: 'or',
        chatWithUs: 'Chat with us'
    };
    return resources[label];
}

